import "../styles/cards.scss";

export function HomeCard2(props) {
    return (
        <div className="homeCard2" onClick={() => {
            window.location.href="detail?num=" + props.num
        }}>
            <img  src={props.img} />
            <div className="homeCard2Text"> {props.text}</div>
        </div>
    );
}
